import React from 'react';
import { Trans } from 'react-i18next';
import gql from 'graphql-tag';

import AdminTab from './AdminTab';
import PATHS from '../../constants/paths';
import './AdminTabs.scss';
import usePageQuery, {
  buildQuery,
  UsePageQueryResult,
} from '../../hooks/usePageQuery';
import { AdminTabsFragment } from '../../../types/__generated__';

const FRAGMENT = buildQuery(gql`
  fragment AdminTabs on Page {
    legacyId
  }
`);

export const TeamAdminTabs = () => {
  const result = usePageQuery<AdminTabsFragment>(FRAGMENT);

  if (!UsePageQueryResult.hasData(result)) {
    return null;
  }

  const { legacyId } = result.data;

  return (
    <nav
      className="jg-pages-admin-tabs jg-background--white"
      data-qa="admin-tabs"
    >
      <ul className="jg-list--inline jg-space-mbn jg-space-phxs jg-space-phsm@md container">
        <AdminTab isActive link="">
          <Trans i18nKey="adminTabs.view">View</Trans>
        </AdminTab>
        <AdminTab link={`${PATHS.TEAMS_CREATION}manage/${legacyId}/edit-team`}>
          <Trans i18nKey="adminTabs.edit">Edit</Trans>
        </AdminTab>
        <AdminTab link={`${PATHS.TEAMS_CREATION}manage/${legacyId}/settings`}>
          <Trans i18nKey="adminTabs.settings">Settings</Trans>
        </AdminTab>
        <AdminTab
          link={`${PATHS.TEAMS_CREATION}manage/${legacyId}/edit-members`}
        >
          <Trans i18nKey="adminTabs.members">Members</Trans>
        </AdminTab>
      </ul>
    </nav>
  );
};

export default TeamAdminTabs;
